const dummyIdeas = [
  {
    id: 1,
    title: "Improve machine uptime",
    submittedBy: "Alice",
    date: "2025-05-01",
  },
  {
    id: 2,
    title: "Reduce packaging waste",
    submittedBy: "Bob",
    date: "2025-05-02",
  },
  {
    id: 3,
    title: "Add safety signage",
    submittedBy: "Charlie",
    date: "2025-05-03",
  },
  {
    id: 4,
    title: "Optimize warehouse layout",
    submittedBy: "Dana",
    date: "2025-05-03",
  },
  {
    id: 5,
    title: "Introduce daily huddles",
    submittedBy: "Eve",
    date: "2025-05-04",
  },
  {
    id: 6,
    title: "Digitalize inspection checklists",
    submittedBy: "Frank",
    date: "2025-05-04",
  },
  {
    id: 7,
    title: "Improve lighting in workstations",
    submittedBy: "Grace",
    date: "2025-05-04",
  },
  {
    id: 8,
    title: "Create onboarding video",
    submittedBy: "Heidi",
    date: "2025-05-04",
  },
  {
    id: 9,
    title: "Upgrade coffee machine ☕",
    submittedBy: "Ivan",
    date: "2025-05-04",
  },
  {
    id: 10,
    title: "Weekly knowledge sharing session",
    submittedBy: "Judy",
    date: "2025-05-04",
  },
];

export default dummyIdeas;
